<h2>
  Add User
</h2>

<div class="body">
  <div
    class="message"
  >
    Provide the Motion username or email belonging to the user with whom you want to share this {{ object.type }}.
  </div>

  <div class="input-form">
    <input
      #dialogBoxInput
      (keyup.enter)="executeCurrentAction()"
      (ngModelChange)="onUserInputChange()"
      [(ngModel)]=userInput
      [ngClass]="{'error': inputError, 'success': selectedUser && !inputError}"
      autocomplete="off"
    >
    @if (showSearchDropdown && users.length) {
      <motn-popover-menu
        (clickedOption$)="onClickedOption($event)"
        (clickedOutsideMenu$)="showSearchDropdown = false"
        [optionGroup]="scrollableHeightMenuOptions"
        [overlayPositions]="scrollableHeightPopoverPositions"
      ></motn-popover-menu>
    }
    <div class="error-message">{{ inputError }}</div>
  </div>


  @if (selectedUser) {
    <div class="message">
      Select the roles for the user:
    </div>
    <div class="role-picker-row">
      <motn-pill-multiselect
        [items]="RoleOptions"
        [selected]="selectedRoleOptions"
        [requireAtLeastOne]="true"
        [errorMsgInline]="true"
        [openMenu$]="rolePickerOpenMenu$"
        (add)="onAddingRole($event)"
        (remove)="onRemovingRole($event)"
      >
        <div class="plus-btn" (click)="onAddRoleClick()">
          <i class="far fa-plus"></i>
        </div>
      </motn-pill-multiselect>
    </div>
  }

  <div class="buttons">
    @if (!selectedUser) {
      <a>
        <button
          (click)="search()"
          [class.loading]="isLoading"
          [disabled]="isActionButtonDisabled"
          class="blue"
        >
          <motn-spinner></motn-spinner>
          <span>
            Search
          </span>
        </button>
      </a>
    }
    @if (selectedUser) {
      <a>
        <button
          (click)="submit()"
          [class.loading]="isLoading"
          [disabled]="isActionButtonDisabled"
          class="green"
        >
          <span>
            Add User
          </span>
          <motn-spinner></motn-spinner>
        </button>
      </a>
    }
    <a>
      <button
        (click)="closeModal()"
      >
        <span>
          Cancel
        </span>
        <motn-spinner></motn-spinner>
      </button>
    </a>
  </div>
</div>
